import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 5),
    borderBottom: "1px solid #e5e5e7",
  },
}));
